import { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { HeaderProvider } from "./Providers/HeaderContextProvider";
import { FunctionalityAccessProvider } from "./Providers/FunctionalityAccessProvider";
import { FCMNotificationProvider } from "./Contexts/FCMNotificationContext";
import Layout from "./Layout";
import DefaultLoader from "./Pages/LoadingPage/DefaultLoader";

function App() {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <HelmetProvider>
        <HeaderProvider>
          <FunctionalityAccessProvider>
            <FCMNotificationProvider>
              <Layout />
            </FCMNotificationProvider>
          </FunctionalityAccessProvider>
        </HeaderProvider>
      </HelmetProvider>
    </Suspense>
  );
}

export default App;
